import { render } from "./MobileAppOffer.vue?vue&type=template&id=4f118f0d&scoped=true"
import script from "./MobileAppOffer.vue?vue&type=script&lang=js"
export * from "./MobileAppOffer.vue?vue&type=script&lang=js"

import "./MobileAppOffer.vue?vue&type=style&index=0&id=4f118f0d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f118f0d"]])

export default __exports__